import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs/operators';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';
import { PolluxDynamicFieldConfig } from '../../../pipes/rd-localized-dynamic-field.pipe';
import { RdLocalizedNumberPipe } from '../../../pipes/rd-localized-number.pipe';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

/**
 * Direct Cap Lease Comparables Summary Widget
 */
@Component({
  selector: 'lease-comparables-summary-widget',
  templateUrl: './lease-comparables-summary-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './lease-comparables-summary-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LeaseComparablesSummaryWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("leaseComparablesSummary", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }

    this.mockupData$ = this.widgetService.loadMockup('leaseComparablesSummary').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('leaseComparablesSummary', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector, private rdLocalizedNumberPipe: RdLocalizedNumberPipe) {
    super(injector, 'leaseComparablesSummary', false);
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    data.labels = {};

    if (data.rows.length) {
      const row = data.rows[0];

      for (let i = 1; i <= 24; ++i) {
        const labelName = `usLeaseCompsCat${i}Label`

        data.labels[labelName] = row[labelName];
      }
      data.labels["usLeaseCompsSummaryEgiLabel"] = row["usLeaseCompsSummaryEgiLabel"];
      data.labels["usLeaseCompsSummaryExpLabel"] = row["usLeaseCompsSummaryExpLabel"];
      data.labels["usLeaseCompsSummaryNoiLabel"] = row["usLeaseCompsSummaryNoiLabel"];


      for (let rowIndex = 0; rowIndex < data.rows.length; ++rowIndex) {
        const row = data.rows[rowIndex];
        row.dynamicData = {};

        for (let i = 1; i <= 24; ++i) {
          const dynamicData: PolluxDynamicFieldConfig = {
            label: row[`usLeaseCompsCat${i}Label`],
            dateValue: row[`usLeaseCompsCat${i}DateValue`],
            decimalValue: row[`usLeaseCompsCat${i}DecimalValue`],
            intValue: row[`usLeaseCompsCat${i}IntValue`],
            textValue: row[`usLeaseCompsCat${i}TextValue`],
            numberFormat: row[`usLeaseCompsCat${i}NumberFormat`]
          };

          row.dynamicData[`usLeaseCompsCat${i}`] = dynamicData;
        }
      }

    }
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData?.rows?.length * 3 + 4;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}
